import { useMutation, useQueryClient } from "@tanstack/react-query";
import { t } from "ttag";

import { fillMissingInformation } from "@/app/api/portal-user";
import { appQueriesStore } from "@/app/api/queries";
import { errorToast, useToastStore } from "@/shared/ui";

export const useFillMissingInformation = () => {
  const pushToast = useToastStore((state) => state.pushToast);

  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: fillMissingInformation,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: appQueriesStore.user.queryKey,
      });
      void queryClient.invalidateQueries({
        queryKey: appQueriesStore.patient.queryKey,
      });

      void pushToast({
        type: "success",
        title: t`Success`,
        message: t`Profile successfully updated!`,
      });
    },
    onError: errorToast,
  });
};
